import React from "react";

const LABEL_OPTIONS = ["Per quantity", "Single label"];
const TYPE_OPTIONS = ["UPCA", "GS128"];
const UOM_OPTIONS = ["kg", "CS"];

export default function BarcodeSecondUomSection({
  rows,
  setRows,
  isVariant = false,
  lockGenerated = false,
}) {
  const isLocked = isVariant || lockGenerated;

  const updateRow = (index, field, value) => {
    if (isLocked) return;
    setRows((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-3 sm:p-6 md:p-8 min-w-0 w-full max-w-full overflow-hidden">
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h2 className="text-lg sm:text-xl md:text-2xl font-semibold">
          Barcode / Second UOM
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                #
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                EAN/UPC
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Second UOM
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Quantity Default
              </th>
              <th className="w-[34%] px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Type
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Label Printing
              </th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {rows.length === 0 ? (
              <tr>
                <td
                  colSpan={7}
                  className="px-6 py-10 text-center text-sm text-gray-500"
                >
                  Generate SKU to auto-create barcode/UOM entries.
                </td>
              </tr>
            ) : (
              rows.map((row, index) => (
                <tr key={row.id} className="bg-blue-50">
                  <td className="px-6 py-4 text-sm font-medium">{index + 1}</td>
                  <td className="px-6 py-4">
                    <input
                      value={row.eanUpc || ""}
                      onChange={(e) =>
                        updateRow(index, "eanUpc", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-mono"
                      placeholder="12-digit UPC"
                      readOnly={isLocked}
                    />
                  </td>
                  <td className="px-6 py-4">
                    <select
                      value={row.secondUom || "kg"}
                      onChange={(e) =>
                        updateRow(index, "secondUom", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      disabled={isLocked}
                    >
                      {UOM_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="px-6 py-4">
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={row.quantityDefault ?? 0}
                      onChange={(e) =>
                        updateRow(index, "quantityDefault", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      readOnly={isLocked}
                    />
                  </td>
                  <td className="w-[34%] px-6 py-4">
                    <input
                      value={row.description || ""}
                      onChange={(e) =>
                        updateRow(index, "description", e.target.value)
                      }
                      className="w-full min-w-[320px] px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      readOnly={isLocked}
                    />
                  </td>
                  <td className="px-6 py-4">
                    <select
                      value={row.type || "UPCA"}
                      onChange={(e) => updateRow(index, "type", e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      disabled={isLocked}
                    >
                      {TYPE_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="px-6 py-4">
                    <select
                      value={row.labelPrinting || "Per quantity"}
                      onChange={(e) =>
                        updateRow(index, "labelPrinting", e.target.value)
                      }
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                      disabled={isLocked}
                    >
                      {LABEL_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
